import { showLoadingBar, removeLoadingBar } from "./global.js";

var submitForm;
(function($) {
	submitForm = function() {
		showLoadingBar();
		$('button[type="submit"]').find('span').addClass('hidden');
		$('button[type="submit"]').find('svg').removeClass('hidden');
	}
	$(document).on('submit','form',function(e) {
		submitForm();
	});
})(jQuery);


export function resetSubmitBtn() {
	removeLoadingBar();
	$('button[type="submit"]').find('span').removeClass('hidden');
	$('button[type="submit"]').find('svg').addClass('hidden');
}

//Being Human payment forms is a <form> with `data-freeform` attribute and is on page slug `being-human-conversation-cards`
if (window.location.pathname.includes('being-human-conversation-cards')) {
	var form = document.querySelector('form[data-freeform]');
	form.addEventListener('freeform-ajax-after-submit', function (event) {
				
		// Select all required elements
		const quantityInput = document.querySelector('input[name="howManyPacks"]');
		const priceDisplay = document.getElementById('bh-card-price');
		const donationInput = document.querySelector('input[name="paymentAmount"]');

		// Check if critical elements exist before proceeding
		if (quantityInput && priceDisplay) {
			/**
			 * Calculates the total price based on the quantity using the updated pricing rules.
			 * 1-4 packs: £8.00 each
			 * 5 packs: £37.00
			 * 6-10 packs: £37.00 + £7.00 for each pack over 5
			 * * @param {number} quantity - The number of packs.
			 * @returns {number} The total price.
			 */
			function calculatePrice(quantity) {
				// Enforce a minimum of 0 for calculation safety
				quantity = Math.max(0, quantity);

				if (quantity === 0) {
					return 0.00;
				} else if (quantity >= 1 && quantity <= 4) {
					// 1-4 items: £8.00 each
					return quantity * 8.00;
				} else if (quantity === 5) {
					// 5 items: Fixed price £37.00
					return 37.00;
				} else if (quantity >= 6 && quantity <= 10) {
					// 6-10 items: £37.00 for the first 5, then £7.00 for each additional item
					const basePrice = 37.00;
					const additionalPacks = quantity - 5; // e.g., if quantity is 7, additionalPacks is 2
					const additionalCost = additionalPacks * 7.00;
					return basePrice + additionalCost;
				}
				
				// Return 0.00 if quantity is out of the 1-10 max range (though input should enforce this)
				return 0.00;
			}

			/**
			 * Updates the price display and the hidden donation input with the calculated price.
			 */
			function updatePrice() {
				// Ensure the input value is treated as an integer, defaulting to 0
				let quantity = parseInt(quantityInput.value, 10) || 0;

				// Enforce max quantity of 10 and ensure it's not negative
				const effectiveQuantity = Math.min(Math.max(quantity, 0), 10);
				
				// Update the input field value if it was changed by the max/min enforcement
				if (effectiveQuantity !== quantity) {
					quantityInput.value = effectiveQuantity;
				}

				const totalPrice = calculatePrice(effectiveQuantity);
				// Format the price to two decimal places (e.g., 8.00)
				const formattedPrice = totalPrice.toFixed(2);

				// 1. Update the visible price display (#bh-card-price)
				priceDisplay.textContent = formattedPrice;

				// 2. Update the hidden input (name="donationAmount")
				if (donationInput) {
					donationInput.value = formattedPrice;
				}
			}

			// 1. Initial price calculation is executed immediately
			updatePrice();

			// 2. Attach event listeners
			quantityInput.addEventListener('input', updatePrice);
			quantityInput.addEventListener('change', updatePrice);
		}
	});
}


//Discovering Jesus form page (discovering-jesus/payment-form)
if (window.location.pathname.includes('discovering-jesus/payment-form')) {
	var form = document.querySelector('form[data-freeform]');
	form.addEventListener('freeform-ajax-after-submit', function (event) {
				// Select all required elements
		const smallPackInput = document.querySelector('input[name="smallPackQuantity"]');
		const largePackInput = document.querySelector('input[name="largePackQuantity"]');
		const extraBookInput = document.querySelector('input[name="extraBookQuantity"]');

		// The element that displays the price to the user (change ID if needed)
		const priceDisplay = document.getElementById('order-total-price'); 

		// The hidden input that holds the price for form submission (reuse name from old script)
		const donationInput = document.querySelector('input[name="paymentAmount"]');

		// Define the prices for clarity
		const SMALL_PACK_PRICE = 2.00; // 1P + 1L for £2
		const LARGE_PACK_PRICE = 12.00; // 10P + 2L for £12
		const EXTRA_BOOK_PRICE = 1.00; // Individual book for £1

		// Check if critical elements exist before proceeding
		if (smallPackInput && largePackInput && extraBookInput && priceDisplay) {

			/**
			 * Calculates the total price based on the three quantities.
			 * @param {number} smallPacks - The number of 1-booklet packs.
			 * @param {number} largePacks - The number of 10-booklet packs.
			 * @param {number} extraBooks - The number of individual extra books.
			 * @returns {number} The total price.
			 */
			function calculatePrice(smallPacks, largePacks, extraBooks) {
				// Enforce a minimum of 0 for calculation safety
				smallPacks = Math.max(0, smallPacks);
				largePacks = Math.max(0, largePacks);
				extraBooks = Math.max(0, extraBooks);

				// Calculate cost for each type of purchase
				const smallPackCost = smallPacks * SMALL_PACK_PRICE;
				const largePackCost = largePacks * LARGE_PACK_PRICE;
				const extraBookCost = extraBooks * EXTRA_BOOK_PRICE;

				// Sum the costs
				const total = smallPackCost + largePackCost + extraBookCost;
				
				return total;
			}

			/**
			 * Reads values from inputs, calculates the total price, and updates the display/hidden input.
			 */
			function updatePrice() {
				// Read values from the input fields, defaulting to 0 if not a valid number
				const smallPacks = parseInt(smallPackInput.value, 10) || 0;
				const largePacks = parseInt(largePackInput.value, 10) || 0;
				const extraBooks = parseInt(extraBookInput.value, 10) || 0;

				const totalPrice = calculatePrice(smallPacks, largePacks, extraBooks);
				
				// Format the price to two decimal places (e.g., 24.00)
				const formattedPrice = totalPrice.toFixed(2);

				// 1. Update the visible price display
				priceDisplay.textContent = formattedPrice;

				// 2. Update the hidden payment input
				if (donationInput) {
					donationInput.value = formattedPrice;
				}
			}

			// 1. Initial price calculation is executed immediately
			updatePrice();

			// 2. Attach event listeners to ALL relevant inputs
			smallPackInput.addEventListener('input', updatePrice);
			smallPackInput.addEventListener('change', updatePrice);
			
			largePackInput.addEventListener('input', updatePrice);
			largePackInput.addEventListener('change', updatePrice);

			extraBookInput.addEventListener('input', updatePrice);
			extraBookInput.addEventListener('change', updatePrice);
		}
	});
}